
import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import { Form } from "antd";
import _ from 'lodash'

const BurpsuiteEnterpriseMappingForm = forwardRef(function BurpsuiteEnterpriseMappingForm({ disableProjectFields = false, ...props }, ref) {
  const [form] = Form.useForm();

  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { siteId, name  } = props.record;
      const siteIdArray = siteId.split(',');
      const nameArray = name.split(',');
      return siteIdArray.map((id, index) => ({id, name: nameArray[index]}))
    }
    return [];
  });

  useEffect(() => {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(projects);
      }).catch((err)=>{
        message.error('Problem fetching projects')
      });
      
      return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    let { siteId } = config;
    siteId = _.isArray(siteId) ? siteId: [siteId]
    const data = projects.reduce((acc,cv) =>{
      const { id, name } = cv;
      if(siteId.includes(id)){
        acc.id.push(Number(id));
        acc.name.push(name);
      }
      return acc;
    },{id:[],name:[]})
    return {
      siteId: data.id.join(','),
      name: data.name.join(','),
      ...(config.discovery_config_id && {
        discovery_config_id: config.discovery_config_id,
      }),
    };
  }

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { siteId } = config;
    return {
      siteId: siteId.split(","),
      ...(config.discovery_config_id && {
        discovery_config_id: config.discovery_config_id,
      }),
    };
  }, []);

  const extraFields = useMemo(() => ([{
      name: 'siteId',
      colSpan: '12',
      type: FieldTypes.MULTI_SELECT,
      label: 'Site Name',
      disabled: disableProjectFields,
      options: projects.map(option => {
        const { label = option.name, value = option.id } = option;
        return { label, value }
      }),
      required: true,
      props: {
        autoFocus: true
      }
    }
  ]), [disableProjectFields, projects]);

  return (
    <GenericMappingForm
      ref={ref}
      form={form}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      {...props}
    />
  )
})

export default BurpsuiteEnterpriseMappingForm;
